import config_base from "./config_base";

let baseUrl = "https://ginfo.cedd.gov.hk";
let config = config_base(baseUrl);

export default {
  ...config,
};
